import type { User } from '~/modules/users/model'

export const renderUserName = ({ name }: User) => {
  return name.firstName && name.lastName ? `${name.firstName} ${name.lastName}` : ''
}

/*
 * converts "CamelCaseString" to "Camel Case String". Used for presenting Role names.
 */
export const camelCaseToSpaces = (input: string): string => input.replace(/([a-z])([A-Z])/g, '$1 $2')
